import { Progress } from "./ui/progress";

export const RenderProgress = ({ progress, queued }) => {
  const percent = Math.max(0, Math.min(100, Number(progress?.percent) || 0));
  const seconds = progress?.eta_seconds;
  const eta = Number.isFinite(seconds)
    ? seconds < 60 ? `About ${Math.max(1, Math.ceil(seconds))} seconds remaining`
      : `About ${Math.ceil(seconds / 60)} minutes remaining`
    : queued ? "Waiting for an available worker" : "Estimating time remaining…";
  return <div data-testid="render-live-progress" className="mt-3 space-y-2 max-w-lg">
    <div className="flex items-center justify-between gap-3 font-mono text-xs">
      <span data-testid="render-stage" className="text-zinc-400">{progress?.stage || (queued ? "Queued" : "Rendering")}</span>
      <span data-testid="render-percent" className="text-blue-400 tabular-nums">{Math.floor(percent)}%</span>
    </div>
    <Progress data-testid="render-progress-bar" value={percent} aria-label="Video rendering progress"
      aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}
      className="h-2 rounded-none bg-zinc-800 [&>div]:bg-blue-500 [&>div]:transition-transform" />
    <p data-testid="render-eta" className="font-mono text-[11px] text-zinc-400">{eta}</p>
  </div>;
};
